import React, { Component } from 'react';

import './ScreenContacts.css';

import Partners from '../../backgrounds/Partners';
import SquarePreloader from '../../components/Preloaders/SquarePreloader';

class BlockContacts extends Component
{
  constructor(props)
  {
    super(props);
    this.state = { preloaderVisible : '' };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event)
  {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  send(e)
  {
    e.preventDefault();

    this.setState({preloaderVisible : 'visible'})
    this.preloader = new SquarePreloader('form-loader-circle');

    fetch('/send', {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                                            name : this.state.name,
                                            email : this.state.email,
                                            message : this.state.message
                                        })
    })
    .then((response) => this.postComplete(response));
  }

  postComplete(response)
  {
    setTimeout(() => { //give some time for animation to play
      this.preloader.destroy();
      this.setState({preloaderVisible : '', name : "", email : "", message : ""});

    }, 1000)

  }

  render()
  {
      return (
        <div className="index-block bg-white" id="BlockContacts">
          <Partners />
          <div className="container">
            <div className="row main">
              <div className="col-xs-12 col-md-12">
                <h3>Contacts</h3>
                <hr />
                <br />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-md-4">
                <p>Virtual & augmented reality, web, apps and game solutions for creatives industries.</p>
                <br />
                <p><a href="tel:+43 664 3576675"><i className="fa fa-phone" aria-hidden="true"></i> +43 6643576675</a></p>
                <br />
              </div>

              <div id="contact-form" className="col-xs-12 col-md-5 pull-right form">
                <div className="wrapForLoader">
                  <div id="form-loader" className={this.state.preloaderVisible}>
                    <div id="form-loader-circle"></div>
                  </div>
                  <div className="form-group"><input type="text" value={this.state.name} onChange={this.handleInputChange} name="name" placeholder="Full name" /></div>
                  <div className="form-group"><input type="email" value={this.state.email} onChange={this.handleInputChange} name="email" placeholder="Email" /></div>
                  <div className="form-group"><textarea value={this.state.message} onChange={this.handleInputChange} placeholder="Message" name="message"
                   rows="4" /></div>
                  <div className="form-group" ><button onClick={(e) => this.send(e)}>Submit</button></div>
                </div>
              </div>
            </div>

            <div className="row copyright">
              <div className="col-xs-12 col-md-4">
                © 2017 <strong>12BROLS</strong>
              </div>
            </div>
          </div>
        </div>
      )
  }
}

export default BlockContacts;



// WEBPACK FOOTER //
// ./src/screens/screenContacts/BlockContacts.js